module.exports = __webpack_public_path__ + "static/media/mi11.ef2f6588.jpg";